import React, { useEffect } from "react";
import {
  Icon,
  Button,
  Col,
  RSelect,
} from "../../components/Component";
import {
  Modal,
  ModalBody,
  Form
} from "reactstrap";
import { useForm } from "react-hook-form";
import { filterStatus } from "../../service/Data";
import { handlePostApis } from "../../service/Api";

const FormModal = ({modal,closeModal, fetchCategory, formData, setFormData, modalType}) => {
  
  useEffect(() => {
    reset(formData)
  }, [formData]);
  const { reset, register, handleSubmit, formState: { errors } } = useForm();

  const handleTdDataPost = () => {
    const data = {
      title: formData?.title,
      is_active: formData?.is_active
    }
    const {title } = formData
    if (!title) {
      return;
    }
    else {
      const res = handlePostApis(`admin/add/offerbar`, data)
    res.then(function (result) {

      if (result) {
        alert(result.data.message)
        closeModal();
        fetchCategory();
      }
    })
    }
  }
  // Traveldeals Update
  const handleUpdateTravelDeals = () => {
    const data = {
      id: formData.id,
      title: formData.title,
      is_active: formData.is_active
    }
    const res = handlePostApis(`admin/update/offerbar`, data)
    res.then(function (result) {
      console.log(result)
      if (result) {
        alert(result.data.message)
        fetchCategory();
        closeModal();
      }
    })
  }

  console.log(formData,'formblog');
  
  return (
    <Modal isOpen={modal} toggle={() => closeModal()} className="modal-dialog-centered" size="lg">
        <ModalBody>
          <a
            href="#cancel"
            onClick={(ev) => {
              ev.preventDefault();
              closeModal();
            }}
            className="close"
          >
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="p-2">
            <h5 className="title">{modalType === "add" && "Add Offer Title"} {modalType === "edit" && "Update Offer Title"}</h5>
            <div className="mt-4">
                      <Form className="row gy-4" onSubmit={handleSubmit(() => {
              modalType === 'add' ? handleTdDataPost() : handleUpdateTravelDeals();
            })}>
                   
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label">Title</label>
                    <input
                      type="text"
                      {...register('title', { required: "This field is required" })}
                      value={formData.title}
                      placeholder="Enter title"
                      onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                      className="form-control" />
                    {errors.title && <span className="invalid">{errors.title.message}</span>}
                  </div>
              </Col>
                <Col md="6">
                    <div className="form-group">
                      <label className="form-label">Status</label>
                      <div className="form-control-wrap">
                        <RSelect
                          options={filterStatus}
                          value={{
                            value: formData.is_active,
                            label: formData.is_active ? "True" : "False",
                          }}
                          onChange={(e) => setFormData({ ...formData, is_active: e.value })}
                        />
                      </div>
                    </div>
                  </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                    <Button color="primary" size="md" type="submit">
                        {modalType === "add" && "Submit"} {modalType === "edit" && "Submit"}
                      </Button>
                    </li>
                    <li>
                      <Button
                        onClick={(ev) => {
                          ev.preventDefault();
                          closeModal();
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </Button>
                    </li>
                  </ul>
                </Col>
              </Form>
            </div>
          </div>
        </ModalBody>
      </Modal>
  );
};
export default FormModal;
